// 快讯日历接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
// homeClient客户端, testwikidatacenter服务端
const { homeClient } = apiList

export default axios => ({
  // 初始化 /wikifxweb-v1/live/calendar/index/init-v1
  searchDealer: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/trader/dropdown-v1`, params),

  postUserInfo: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/contact/submit-v1`, params)
})
